import * as actions from '@/pages/signin/store/signin-actions';
import { state } from '@/pages/signin/store/signin-state';

export const signin = {
  state,
  actions,
};
